<!-- <ion-header [translucent]="true">
  <ion-toolbar>
    <ion-title>register</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <ion-header collapse="condense">
    <ion-toolbar>
      <ion-title size="large">register</ion-title>
    </ion-toolbar>
  </ion-header>
</ion-content> -->


<ion-header>
  <ion-toolbar>
    <ion-title>Register</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <form [formGroup]="registrationForm" (ngSubmit)="onSubmit()">
    <ion-list>
      <!-- First Name -->
      <ion-item>
        <ion-label position="floating">First Name</ion-label>
        <ion-input formControlName="firstName"></ion-input>
        <div *ngIf="registrationForm.get('firstName')?.invalid && registrationForm.get('firstName')?.touched">
          <span class="registration-error-message" *ngIf="registrationForm.get('firstName')?.hasError('required')">First name is required field.</span>
        </div>
      </ion-item>
      
      <!-- Last Name -->
      <ion-item>
        <ion-label position="floating">Last Name</ion-label>
        <ion-input formControlName="lastName"></ion-input>
        <div *ngIf="registrationForm.get('lastName')?.invalid && registrationForm.get('lastName')?.touched">
          <span class="registration-error-message" *ngIf="registrationForm.get('lastName')?.hasError('required')">Last name is required field.</span>
        </div>
      </ion-item>
      
      <!--Age-->
      <ion-item>
        <ion-label position="floating">Age</ion-label>
        <ion-input formControlName="age" type="number"></ion-input>
        <div *ngIf="registrationForm.get('age')?.invalid && registrationForm.get('age')?.touched">
          <span class="registration-error-message" *ngIf="registrationForm.get('age')?.hasError('required')">Age is required field.</span>
        </div>
      </ion-item>
      
      <!-- Gender -->
      <ion-item>
        <ion-label position="floating">Gender</ion-label>
        <ion-select formControlName="gender">
          <ion-select-option value="male" selected>Male</ion-select-option>
          <ion-select-option value="female">Female</ion-select-option>
          <ion-select-option value="other">Other</ion-select-option>
        </ion-select>
        <div *ngIf="registrationForm.get('gender')?.invalid && registrationForm.get('gender')?.touched">
          <span class="registration-error-message" *ngIf="registrationForm.get('gender')?.hasError('required')">Gender is required field.</span>
        </div>
      </ion-item>
      
      
      
      <!-- Accent -->
      <ion-item>
        <ion-label position="floating">Accent</ion-label>
        <ion-input formControlName="accent"></ion-input>
        <div *ngIf="registrationForm.get('accent')?.invalid && registrationForm.get('accent')?.touched">
          <span class="registration-error-message" *ngIf="registrationForm.get('accent')?.hasError('required')">Accent is required field.</span>
        </div>
      </ion-item>
      
      <!-- Username -->
      <ion-item>
        <ion-label position="floating">Username</ion-label>
        <ion-input formControlName="username"></ion-input>
        <div *ngIf="registrationForm.get('username')?.invalid && registrationForm.get('username')?.touched">
          <span class="registration-error-message" *ngIf="registrationForm.get('username')?.hasError('required')">Username is required field.</span>
        </div>
      </ion-item>
      
      <!-- Email -->
      <!-- <ion-item>
        <ion-label position="floating">Email</ion-label>
        <ion-input formControlName="email" type="email"></ion-input>
      </ion-item> -->
      
      <!-- Password -->
      <ion-item>
        <ion-label position="floating">Password</ion-label>
        <ion-input formControlName="password" type="password"></ion-input>
        <div *ngIf="registrationForm.get('password')?.invalid && registrationForm.get('password')?.touched">
          <span class="registration-error-message" *ngIf="registrationForm.get('password')?.hasError('required')">Password is required.</span>
          <span class="registration-error-message" *ngIf="registrationForm.get('password')?.hasError('invalidPassword')">Password must be at least 8 characters long, contain at least one special character, one capital letter, and one number.</span>
        </div>
      </ion-item>
      
      <!-- Confirm Password -->
      <ion-item>
        <ion-label position="floating">Confirm Password</ion-label>
        <ion-input formControlName="confirmPassword" type="password"></ion-input>
        <div *ngIf="registrationForm.hasError('mismatch') && registrationForm.touched">
          <span class="registration-error-message">Passwords do not match.</span>
      </div>
      </ion-item>
      
      <!-- Register Button -->
      <ion-button type="submit" expand="block" [disabled]="!registrationForm.valid">
        Register
      </ion-button>
    </ion-list>



    <ion-row style="margin-top: 20px; text-align: center;">
      <ion-col>
          <span class="link" (click)="navigateToLogin()" style="color: black; cursor: pointer; font-size: 13px;">
              Already have an account? Login here
          </span>
      </ion-col>
  </ion-row>
  </form>
</ion-content>
